const APOLLO_SERVER_URL = process.env.REACT_APP_APOLLO_SERVER_URL
const APPLICATION_TYPE = process.env.REACT_APP_APPLICATION_TYPE
const APPLICATION_KO_ORGANIZATIO_ID = process.env.REACT_APP_APPLICATION_KO_ORGANIZATIO_ID
const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE
const BASE_URL = process.env.REACT_APP_BASE_URL

// Sentry
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT || "production"
const SENTRY_TRACES_SAMPLE_RATE = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1")
const SENTRY_CUSTOMER_NAME = process.env.REACT_APP_SENTRY_CUSTOMER_NAME

export {
    APOLLO_SERVER_URL,
    APPLICATION_TYPE,
    APPLICATION_KO_ORGANIZATIO_ID,
    DEFAULT_LOCALE,
    BASE_URL,
    SENTRY_DSN,
    SENTRY_ENVIRONMENT,
    SENTRY_TRACES_SAMPLE_RATE,
    SENTRY_CUSTOMER_NAME,
}
